import { __decorate } from "tslib";
import { FrontendFeaturePlugin, provideRootRoutes } from '@core/frontend-shared';
import { ClassName } from '@core/shared/class-name';
import * as i0 from "@angular/core";
let MpfContactFrontendAdminFeature = /*#__PURE__*/(() => {
  let MpfContactFrontendAdminFeature = class MpfContactFrontendAdminFeature extends FrontendFeaturePlugin {
    getFeatureContext() {
      return {"package":"@mpf/contact/frontend-admin","featureId":"mpf-contact"};
    }
    getFeatureFunctionality(functionality) {
      functionality.defineMenuItems({
        adminToolbar: [{
          label: 'Kontaktanfragen',
          routerLink: 'contact',
          icon: 'comments',
          items: [{
            label: 'Demo-Anfragen',
            routerLink: 'contact/demo-requests'
          }, {
            label: 'Warteliste',
            routerLink: 'contact/waiting-list'
          }]
        }]
      });
    }
    static {
      this.ɵfac = /*@__PURE__*/(() => {
        let ɵMpfContactFrontendAdminFeature_BaseFactory;
        return function MpfContactFrontendAdminFeature_Factory(__ngFactoryType__) {
          return (ɵMpfContactFrontendAdminFeature_BaseFactory || (ɵMpfContactFrontendAdminFeature_BaseFactory = i0.ɵɵgetInheritedFactory(MpfContactFrontendAdminFeature)))(__ngFactoryType__ || MpfContactFrontendAdminFeature);
        };
      })();
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: MpfContactFrontendAdminFeature
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
        providers: [provideRootRoutes([{
          path: 'contact',
          loadChildren: () => import('./contact-admin.module').then(m => m.ContactFrontendAdminModule)
        }])]
      });
    }
  };
  MpfContactFrontendAdminFeature = __decorate([ClassName("MpfContactFrontendAdminFeature")], MpfContactFrontendAdminFeature);
  return MpfContactFrontendAdminFeature;
})();
export { MpfContactFrontendAdminFeature };